/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgShieldLockSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgShieldLockSolid"
    {...props}
  >
    {props.children}
    <g fill="#0d0d0d">
      <path
        fillRule="evenodd"
        d="M13.8 10.639c.484 0 .803 0 1.047.02.236.02.336.052.394.081.177.09.32.23.408.402.028.055.061.15.08.38.02.24.02.554.02 1.034v.777c0 .48 0 .793-.02 1.033-.019.23-.052.326-.08.38a.93.93 0 0 1-.408.402c-.058.03-.158.062-.394.081-.244.02-.563.02-1.047.02h-3.6c-.484 0-.804 0-1.048-.02-.235-.019-.335-.052-.393-.08a.93.93 0 0 1-.409-.403c-.027-.054-.06-.15-.08-.38-.02-.24-.02-.554-.02-1.033v-.777c0-.48 0-.794.02-1.034.02-.23.053-.325.08-.38a.93.93 0 0 1 .409-.402c.058-.029.158-.062.393-.08.244-.02.564-.021 1.048-.021zm-1.8 1a.75.75 0 0 0-.75.75v1.11a.75.75 0 0 0 1.5 0v-1.11a.75.75 0 0 0-.75-.75"
        clipRule="evenodd"
      />
      <path d="M12 6.75c1.148 0 2.062.916 2.062 2.027v.363l-.262-.001H9.937v-.362c0-1.11.915-2.027 2.063-2.027" />
      <path
        fillRule="evenodd"
        d="M11.714 1.089a2 2 0 0 1 .572 0c.219.031.423.108.584.169l.043.016 5.492 2.06c.618.23 1.16.433 1.578.8.366.323.647.73.82 1.185.199.52.198 1.1.197 1.759V12c0 2.827-1.538 5.183-3.2 6.914-1.672 1.743-3.586 2.974-4.598 3.564l-.041.025a2.4 2.4 0 0 1-.741.316 2.1 2.1 0 0 1-.84 0 2.4 2.4 0 0 1-.741-.316l-.041-.025c-1.012-.59-2.926-1.821-4.599-3.564C4.537 17.183 3 14.826 3 12V7.078c0-.66 0-1.238.197-1.759.173-.455.455-.862.82-1.184.418-.368.961-.57 1.579-.801l5.492-2.06.044-.016c.161-.061.364-.138.583-.17M12 5.249C10.04 5.25 8.438 6.82 8.437 8.778v.49c-.119.034-.238.075-.353.133-.458.23-.832.6-1.067 1.055-.156.302-.215.62-.242.944-.026.316-.025.703-.025 1.157v.777c0 .454 0 .841.025 1.157.027.325.087.641.242.943.235.456.61.825 1.067 1.055.303.153.62.21.947.236.319.026.709.026 1.17.026H13.8c.46 0 .85 0 1.169-.025.327-.027.644-.084.947-.237.458-.23.831-.599 1.066-1.055.156-.302.216-.618.243-.943.026-.316.025-.703.025-1.157v-.777c0-.454 0-.84-.025-1.157-.027-.325-.087-.642-.243-.944A2.43 2.43 0 0 0 15.916 9.4a2 2 0 0 0-.354-.133v-.49C15.562 6.82 13.96 5.25 12 5.25"
        clipRule="evenodd"
      />
    </g>
  </svg>
)
